import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

export default function ProtectedRoute({ userType }) {
  console.log("--- PROTECTED ROUTE CHECKING ---");
  console.log("Required role:", userType);

  const token = Cookies.get('token');
  const userRole = Cookies.get('userRole');

  console.log("Found token:", token);
  console.log("Found userRole:", userRole);

  if (!token) {
    console.log("DECISION: No token. Redirecting to login.");
    return <Navigate to={`/${userType}-login`} replace />;
  }
  
  if (userRole !== userType) {
    console.log(`DECISION: Role mismatch. Expected '${userType}' but found '${userRole}'. Redirecting.`);
    return <Navigate to="/" replace />; // Redirecting to homepage on role mismatch
  }
  
  console.log("DECISION: Success! Allowing access.");
  return <Outlet />;
};